import { ValidationError } from '@tanstack/react-form'

// Function validators return plain strings; schema validators (zod) return issue objects.
function validationErrorMessage(error: ValidationError): string | undefined {
	if (typeof error === 'string') {
		return error || undefined
	}
	if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
		return error.message || undefined
	}
	return undefined
}

export function validationErrorMessages(errors: ReadonlyArray<ValidationError> | undefined): string[] {
	return (errors ?? []).map(validationErrorMessage).filter((message): message is string => message !== undefined)
}
